import React from 'react';
import { BOTTOM_NAVIGATION } from '../config/constant';
import { 
  Box, 
  Paper, 
  Typography, 
  Button 
} from '@mui/material';
import { 
  Schedule as ScheduleIcon,
  AccessTime as AccessTimeIcon
} from '@mui/icons-material';

function CardShowBus (props) {
  const displayBusContent = () => {
    // Store the desired tab in sessionStorage
    sessionStorage.setItem('busTabView', 'time');
    
    // Set the bottom navigation to Bus tab
    props.updateBottomNavigationTab(BOTTOM_NAVIGATION.BUS);
    props.displayFullScreen(false);
  };

  return (
    <Paper
      elevation={2}
      onClick={displayBusContent}
      sx={{
        borderRadius: 3,
        overflow: 'hidden',
        mb: 1.5,
        position: 'relative',
        background: 'white',
        border: '1px solid rgba(0,0,0,0.08)',
        transition: 'all 0.2s ease',
        cursor: 'pointer',
        '&:hover': {
          boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
          transform: 'translateY(-2px)'
        }
      }}
    >
      <Box sx={{ position: 'relative' }}>
        <img 
          src={props.img} 
          alt="Bus" 
          style={{ 
            width: '100%', 
            height: 'auto', 
            display: 'block',
            maxHeight: '200px',
            objectFit: 'cover'
          }} 
        />
      </Box>

      <Box sx={{ p: 3 }}>
        <Typography variant="h5" component="h2" fontWeight="600" sx={{ mb: 1, color: '#333' }}>
          {props.title}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {props.description}
        </Typography>
        
        <Button
          variant="outlined"
          color="secondary"
          disableElevation
          fullWidth
          startIcon={<AccessTimeIcon />}
          sx={{
            mt: 1,
            py: 1.5,
            borderColor: 'rgba(156, 39, 176, 0.5)',
            color: '#9c27b0',
            textTransform: 'none',
            fontWeight: 'bold',
            fontSize: '1rem',
            borderRadius: 8,
            '&:hover': {
              borderColor: '#9c27b0',
              backgroundColor: 'rgba(156, 39, 176, 0.08)'
            }
          }}
        >
          View Bus Time
        </Button>
      </Box>
    </Paper>
  );
}

export default CardShowBus;
